import { LampDto } from "../interfaces";
import { getLampQrCodeUrl } from "../routers";

export const getQrCodeItemForLamp = (lamp: LampDto, switchPointId: number, lampBranchId: number, lauId: number) => {
	return {
		value: getLampQrCodeUrl(switchPointId, lampBranchId, lamp.id, lauId, lamp.hash),
		label: lamp.oznaceni,
		description: "Nahlášení závady",
	};
};